<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'

    >
      <v-card-text>
        <span v-if='!estimateDetail.schedule_notes'>None...</span>
        <span v-html='estimateDetail.schedule_notes'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        v-model='estimateDetailCopy.schedule_notes'
        outlined
        auto-grow
        hint='Notes to office for production schedule spreadsheet'
        persistent-hint
      ></v-textarea>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'mechanical-notes',
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    title: 'Prod. Sch. Notes',
    icon: 'mdi-calendar',
    iconColor: '#info',
    estimateDetailCopy: {},
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    save () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    }
  }
}
</script>